import { useEffect } from 'react';

export function useEventListener(
  eventName: string,
  handler: EventListenerOrEventListenerObject,
  element: HTMLElement | Document | null = document
) {
  useEffect(() => {
    if (!element || !element.addEventListener) {
      return;
    }
    element.addEventListener(eventName, handler);

    return () => element.removeEventListener(eventName, handler);
  }, [eventName, element, handler]);
}
